const FORMAT_CHARACTERS = /\p{Cf}/gu;
const ENCODED_RUN = /(?:%[0-9A-Fa-f]{2})+/g;
const ONLY_FORMAT = /^\p{Cf}+$/u;

// Copy from Excel/Outlook/Teams appends Unicode format characters (U+200E LRM
// and friends). Browsers percent-encode them in the path; fetch then rejects
// the decoded character in request headers.
export const stripFormatCharacters = (value: string): string =>
  value
    .replace(ENCODED_RUN, (encoded) => {
      try {
        const decoded = decodeURIComponent(encoded);
        return ONLY_FORMAT.test(decoded) ? "" : encoded;
      } catch {
        return encoded;
      }
    })
    .replace(FORMAT_CHARACTERS, "");
